import cogoToast from "cogo-toast";
import { store } from "../store/store";
import { setlineItem } from "../store/slices/lineitemadded-slice";
import { deleteAllFromCart } from "../store/slices/cart-slice";

export const createOrderApi = async (accessToken) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/orders`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
    });

    const result = await response.json();

    // Check if the response contains an order ID to confirm success
    if (result?.ID) {
      return result; // Return the result object
    } else {
      // If no ID is returned, consider it a failure
      cogoToast.error("Failed to create the order.", {
        position: "bottom-left",
      });
      return false;
    }
  } catch (error) {
    cogoToast.error("An error occurred while saving the order.", {
      position: "bottom-left",
    });
    return false;
  }
};
export const deletelineitemApi = async (accessToken, id, flag) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/lineitem/${id}`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: headers,
    });

    const result = await response.json();
    if (result) {
      store.dispatch(setlineItem(false));
      if (flag === true) {
        cogoToast.success("Successfully deleted line item.", {
          position: "bottom-left",
        });
      }
    }
    return result;
  } catch (error) {
    cogoToast.error("An error occurred while deleting line item.", {
      position: "bottom-left",
    });
    return null;
  }
};
export const addLineItemToOrderApi = async (
  accessToken,
  orderId,
  productId,
  quantity,
  variantId,
  flag
) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/orders/${orderId}/lineitem`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };
  let body = JSON.stringify({
    order_id: orderId, // Pass orderId in both URL and body
    productId: productId,
    quantity: quantity,
  });
  if (variantId) {
    body = JSON.stringify({
      order_id: orderId,
      productId: productId,
      variantId: variantId,
      quantity: quantity,
    });
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: body,
    });

    const result = await response.json();
    if (result) {
      store.dispatch(setlineItem(true));
      if (flag === true) {
        cogoToast.success("Added to Cart.", {
          position: "bottom-left",
        });
      }
    }
    return result;
  } catch (error) {
    cogoToast.error("An error occurred while adding line item.", {
      position: "bottom-left",
    });
    return null;
  }
};
export const upDateLineItem = async (
  id,
  accessToken,
  orderId,
  productId,
  variantId,
  quantity
) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/lineitem/${id}`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };
  let body = JSON.stringify({
    ID: id,
    order_id: orderId,
    productId: productId,
    quantity: quantity,
  });
  if (variantId) {
    body = JSON.stringify({
      ID: id,
      order_id: orderId,
      productId: productId,
      variantId: variantId,
      quantity: quantity,
    });
  }
  console.log(body);

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: body,
    });

    const result = await response.json();
    if (result.status === 1) {
      cogoToast.warn("line item not found.", {
        position: "bottom-left",
      });
    } else {
      store.dispatch(setlineItem(true));
      cogoToast.success("Updated Cart.", {
        position: "bottom-left",
      });
    }
  } catch (error) {
    cogoToast.error("error updating lineitem.", {
      position: "bottom-left",
    });
  }
};
export const fetchOrdersApi = async (accessToken, page = 1, limit = 10) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/orders?page=${page}&limit=${limit}`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });

    const result = await response.json();
    // Check if the status indicates success and if data exists
    if (result?.status === 0 && result?.data?.length > 0) {
      return result.data; // Return the orders data array
    } else {
      return result?.message;
    }
  } catch (error) {
    cogoToast.error("An error occurred while fetching orders.", {
      position: "bottom-left",
    });
    return [];
  }
};

export const fetchOrderDetailApi = async (uuid) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/order-uuid/${uuid}`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });

    const result = await response.json();

    return result;
  } catch (error) {
    cogoToast.error("An error occurred while fetching order details.", {
      position: "bottom-left",
    });
    return null;
  }
};

// Update Order API
export const updateOrderApi = async (
  accessToken,
  orderId,
  customerId,
  customerName,
  email,
  addressId
) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/orders`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };

  let body = JSON.stringify({
    ID: orderId,
    customerId: customerId,
    customerName: customerName,
    shippingAddressId: addressId,
    billingAdressId: addressId,
  });

  if (email) {
    body = JSON.stringify({
      ID: orderId,
      customerId: customerId,
      customerName: customerName,
      shippingAddressId: addressId,
      billingAdressId: addressId,
      customerEmail: email,
    });
  }
  console.log("Body", body);

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: body,
    });

    const result = await response.json();
    if (result?.ID) {
      cogoToast.success("Order updated successfully.", {
        position: "bottom-left",
      });
      return result;
    } else {
      cogoToast.warn("Failed to update the order.", {
        position: "bottom-left",
      });
      return null;
    }
  } catch (error) {
    cogoToast.error("An error occurred while updating the order.", {
      position: "bottom-left",
    });
    console.error("Error updating order:", error);
    return null;
  }
};
export const updateOrderPaymentMethodApi = async (
  accessToken,
  orderId,
  customerId,
  customerName,
  addressId,
  paymentMethod
) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/orders`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };

  const body = JSON.stringify({
    ID: orderId,
    customerId: customerId,
    customerName: customerName,
    shippingAddressId: addressId,
    billingAdressId: addressId,
    paymentMethod: paymentMethod,
  });

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: body,
    });

    const result = await response.json();

    if (result?.ID) {
      return result;
    } else {
      cogoToast.warn("Failed to update the payment.", {
        position: "bottom-left",
      });
      return null;
    }
  } catch (error) {
    cogoToast.error("An error occurred while updating the payment method.", {
      position: "bottom-left",
    });
    console.error("Error updating payment method:", error);
    return null;
  }
};

export const fetchSupportedPaymentGateways = async () => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/supportedpaymentgateways`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });

    const result = await response.json();

    if (result && Array.isArray(result) && result.length > 0) {
      return result;
    } else {
      cogoToast.warn("No supported payment gateways found.", {
        position: "bottom-left",
      });
      return [];
    }
  } catch (error) {
    cogoToast.error(
      "An error occurred while fetching supported payment gateways.",
      {
        position: "bottom-left",
      }
    );
    console.error("Error fetching payment gateways:", error);
    return [];
  }
};
export const placeOrderApi = async (accessToken, orderId, dispatch) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/checkout/${orderId}`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
    });

    const result = await response.json();

    // Check if the response contains an order ID to confirm success
    if (result?.ID) {
      cogoToast.success("Order Placed Successfully", {
        position: "bottom-left",
      });
      dispatch(deleteAllFromCart());
      return result; // Return the result object
    } else if (result?.message) {
      dispatch(deleteAllFromCart());
      cogoToast.success(result.message, {
        position: "bottom-left",
      });
    } else {
      // If no ID is returned, consider it a failure
      cogoToast.error("Failed to place the order.", {
        position: "bottom-left",
      });
      return false;
    }
  } catch (error) {
    cogoToast.error("An error occurred while placing the order.", {
      position: "bottom-left",
    });
    return false;
  }
};
export const applycouponApi = async (
  accessToken,
  coupon,
  orderId,
  setcouponapplied,
  setDiscount,
  setTotalAmount
) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/discounts/${coupon}/apply/${orderId}`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
    });

    const result = await response.json();

    // Check if the response contains an order ID to confirm success
    if (result?.discountAmount) {
      cogoToast.success("Coupon applied successfully", {
        position: "bottom-left",
      });
      setDiscount(result.discountAmount);
      setTotalAmount(result.totalAmount);
    } else if (result?.message) {
      cogoToast.success(result.message, {
        position: "bottom-left",
      });
      setcouponapplied(false);
    } else {
      // If no ID is returned, consider it a failure
      cogoToast.error("Failed to apply coupon .", {
        position: "bottom-left",
      });
      setcouponapplied(false);
      return false;
    }
  } catch (error) {
    cogoToast.error("An error occurred while applying the coupon.", {
      position: "bottom-left",
    });
    return false;
  }
};
export const removeCouponApi = async (
  accessToken,
  orderDetail,
  setcouponapplied,
  setcoupon,
  setTotalAmount,
  setDiscount
) => {
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/orders`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };
  let body = JSON.stringify({
    ID: orderDetail.ID,
    customerId: orderDetail.customerId,
    discountCode: "",
  });

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: body,
    });

    const result = await response.json();

    // Check if the response contains an order ID to confirm success
    if (result?.ID) {
      cogoToast.success("Coupon removed successfully", {
        position: "bottom-left",
      });
      setcoupon("");
      setTotalAmount(result.totalAmount);
      setDiscount(result.discountAmount);
    } else if (result?.message) {
      cogoToast.success(result.message, {
        position: "bottom-left",
      });
      setcouponapplied(true);
    } else {
      // If no ID is returned, consider it a failure
      cogoToast.error("Failed to remove coupon .", {
        position: "bottom-left",
      });
      setcouponapplied(true);
      return false;
    }
  } catch (error) {
    cogoToast.error("An error occurred while removing the coupon.", {
      position: "bottom-left",
    });
    return false;
  }
};

export const removeCouponOnCheckout = async(accessToken,orderDetail)=>{
  const url = `${process.env.REACT_APP_API_HTTPS_URL}/orders`;
  const headers = {
    "Client-Id": `${process.env.REACT_APP_CLIENT_ID}`,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  };
  let body = JSON.stringify({
    ID: orderDetail.ID,
    customerId: orderDetail.customerId,
    discountCode: "",
  });

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: body,
    });

    const result = await response.json();
    console.log(result);
    
    
  } catch (error) {
    console.log(error);
    
    return false;
  }
}
